module.exports = __webpack_public_path__ + "static/img/蒙版组12@3x.2a984bf9.png";